module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAY1BMVEUAAADMzMzMzMzNzc3Nzc3MzMzLy8vNzc3MzMzOzs7Nzc3MzMzMzMzNzc3Nzc3Ly8vPz8/MzMzNzc3MzMzMzMzMzMzMzMzMzMzLy8vMzMzNzc3Ozs7Nzc3Nzc3Ozs6/v7/MzMxW693rAAAAIHRSTlMAgWHIp5qPeGge6NR1bFlWMvff27+zn4dxb1tJPS4VCA9+8WQAAACFSURBVDjLxdJXEoMwEANQjAFDEkp6o+j+p0QXQPqD/dUbe2ZX2a7TTAacUTiAlwQ9gFKKH0UlRU7xtiJIUVMkKVqKrxQfilqKC0UuRaLopAjASR4tAlHk8wO4Ddv58uQHo3igAK5/kZcAepFXZgmBeWuWmNQpzbE7V6i7q2R0tW+G7JhZAX0UCkkrEeqEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/vip_righrt_icon.png
// module id = IrVT
// module chunks = 0